export default __webpack_public_path__ + "static/media/ISKO_CLASS-8_SYLLABUS.df0b6426.pdf";